var render = function render(){
  var _vm=this;
  var _h=_vm.$createElement;
  var _c=_vm._self._c||_h;

  return _c('div', [_c('b-row', {
    staticClass: "mb-4"
  }, [_c('b-col', {
    attrs: {
      "cols": "8"
    }
  }, [_c('h5', [_vm._v("Kan niet leveren")])]), !_vm.isPartialUnableToShipAllowed ? _c('b-col', {
    staticClass: "text-right",
    attrs: {
      "cols": "4"
    }
  }, [_c('small', {
    directives: [{
      name: "b-tooltip",
      rawName: "v-b-tooltip.click",
      value: `Als deel-manco's niet zijn toegestaan wordt altijd de gehele levering op manco gezet, ook bij één manco product. De overige producten uit zo'n levering komen dan dus ook niet meer naar voren als scan suggestie.`,
      expression: "`Als deel-manco's niet zijn toegestaan wordt altijd de gehele levering op manco gezet, ook bij één manco product. De overige producten uit zo'n levering komen dan dus ook niet meer naar voren als scan suggestie.`",
      modifiers: {
        "click": true
      }
    }],
    staticClass: "text-info"
  }, [_c('font-awesome-icon', {
    attrs: {
      "icon": "question-circle"
    }
  })], 1)]) : _vm._e()], 1), _vm.isLoadingSuggestedLines ? _c('div', [_c('font-awesome-icon', {
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }), _c('b-button', {
    staticClass: "d-block mt-4 p-0",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('small', [_vm._v("< terug")])])], 1) : !_vm.selectedProduct ? _c('div', {
    staticClass: "mt-2"
  }, [_c('form', {
    on: {
      "submit": function ($event) {
        $event.preventDefault();
        return _vm.saveUnableToShip.apply(null, arguments);
      }
    }
  }, [_c('div', [_c('b-table-simple', {
    staticClass: "mb-0",
    attrs: {
      "small": "",
      "borderless": ""
    }
  }, [_c('b-thead', [_c('b-tr', [_c('b-th', [_vm._v("Productnr")]), _c('b-th', [_vm._v("Productnaam")]), _c('b-th', [_vm._v("Totaal aantal")]), _c('b-th', [_vm._v("Niet leverbaar")])], 1)], 1), _c('b-tbody', [_vm._l(_vm.products, function (product) {
    return _c('b-tr', [_c('b-td', {
      staticClass: "align-middle"
    }, [_c('product-number', {
      attrs: {
        "number": product.identifier,
        "product-name": product.name,
        "link-class": "text-secondary",
        "show-only-fields": ['name', 'identifier', 'image', 'barcodes']
      }
    })], 1), _c('b-td', {
      staticClass: "align-middle"
    }, [product.name ? _c('span', [_vm._v(_vm._s(product.name))]) : _c('i', [_vm._v("onbekend")])]), _c('b-td', {
      staticClass: "align-middle"
    }, [_vm._v(_vm._s(product.quantity))]), _c('b-td', {
      staticClass: "align-middle"
    }, [_c('b-input', {
      staticStyle: {
        "width": "50px"
      },
      attrs: {
        "type": "number",
        "size": "sm",
        "min": "0",
        "max": product.quantity,
        "placeholder": "0"
      },
      model: {
        value: product.quantitySelected,
        callback: function ($$v) {
          _vm.$set(product, "quantitySelected", _vm._n($$v));
        },
        expression: "product.quantitySelected"
      }
    })], 1)], 1);
  }), !_vm.products.length ? _c('b-tr', [_c('b-td', {
    attrs: {
      "colspan": "4"
    }
  }, [_c('i', [_vm._v("Geen scanbare producten")])])], 1) : _vm._e()], 2)], 1)], 1), _c('b-table-simple', {
    staticClass: "mb-0 mt-3",
    attrs: {
      "small": "",
      "borderless": ""
    }
  }, [_vm.products.length ? _c('b-tr', [_c('b-td', {
    staticClass: "pb-4",
    attrs: {
      "colspan": "4"
    }
  }, [_c('h6', [_vm._v("Selecteer reden")]), _vm._l(_vm.unableToShipReasons, function (reason, index) {
    return _c('div', [_c('input', {
      directives: [{
        name: "model",
        rawName: "v-model",
        value: _vm.selectedReason,
        expression: "selectedReason"
      }],
      staticClass: "mr-2 align-middle",
      attrs: {
        "type": "radio",
        "name": "unableToShipReasons",
        "id": `reason-${index}`,
        "required": ""
      },
      domProps: {
        "value": reason,
        "checked": _vm._q(_vm.selectedReason, reason)
      },
      on: {
        "change": function ($event) {
          _vm.selectedReason = reason;
        }
      }
    }), _c('label', {
      staticClass: "mb-1",
      attrs: {
        "for": `reason-${index}`
      }
    }, [_vm._v(_vm._s(reason))])]);
  })], 2)], 1) : _vm._e(), _c('b-tr', [_c('b-td', [_c('b-button', {
    staticClass: "p-0",
    attrs: {
      "variant": "link",
      "size": "sm"
    },
    on: {
      "click": function ($event) {
        return _vm.$emit('close');
      }
    }
  }, [_c('small', [_vm._v("< terug")])])], 1), _vm.products.length ? _c('b-td', {
    staticClass: "text-right",
    attrs: {
      "colspan": "3"
    }
  }, [_c('b-button', {
    attrs: {
      "variant": "danger",
      "type": "submit",
      "size": "sm",
      "disabled": !_vm.hasSelectedProducts || _vm.isSaving
    }
  }, [_vm._v(" Kan niet leveren "), _vm.isSaving ? _c('font-awesome-icon', {
    staticClass: "ml-1",
    attrs: {
      "icon": "spinner",
      "spin": ""
    }
  }) : _vm._e()], 1)], 1) : _vm._e()], 1)], 1), _c('b-alert', {
    staticClass: "mt-4 mb-0",
    attrs: {
      "show": !!_vm.errorMessage,
      "variant": "danger"
    }
  }, [_c('small', [_vm._v(_vm._s(_vm.errorMessage))])])], 1)]) : _vm._e()], 1);

}
var staticRenderFns = []

export { render, staticRenderFns }